(function ($, document, window) {
	'use strict';

	var desktopLink = $('.js-om-mypages-desktop').parent();
	var mobileLink = $('.js-om-mypages-mobile');
	var panelHolder = $('#om-mypages-panel-holder');
	var loginlink = $('.login-link > a');
	var customerPortalMenu = $('.login-link .om-customer-portal-dropdown');

	var customerPortal = {

		init: function () {
			loginlink.on('click',
				function (event) {
					event.stopPropagation();
					//event.preventDefault();
					customerPortal.setMenuWidth();
					customerPortal.toggleCustomerPortal();
					return false;
				});

			$('.om-mypages-panel').on('click',
				function (event) {
					event.stopPropagation();
				});

			$(document).on('click',
				function () {
					customerPortal.closeCustomerPortal();
				});
		},

		setMenuWidth: function () {
			return;
			$('.om-customer-portal-dropdown').width($('.js-om-mypages-desktop').width());
			var pagesHolder = $('#om-mypages-panel-holder');
			pagesHolder.css({ right: 0 });
		},

		closeCustomerPortal: function () {
			if (panelHolder.height() > 0) {
				panelHolder.stop().animate({
					height: 0,
					opacity: 0
				}, 200, function () {
					desktopLink.removeClass('is-open');
					mobileLink.removeClass('is-open');
				});
			}
		},

		toggleCustomerPortal: function () {
			customerPortal.closeMobileSearch();

			customerPortalMenu.toggleClass('open');
		},

		closeMobileSearch: function () {
			$(document).click();
		}

	};

	customerPortal.init();

})(jQuery, document, window);
